export enum CheckEnrollmentStatus {
	Successful = "AUTHENTICATION_SUCCESSFUL",
	Failed = "AUTHENTICATION_FAILED",
	Pending = "PENDING_AUTHENTICATION",
}
